import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import moment from 'moment';
import { uniqueId, uniqBy } from 'lodash';
import { convertMoney } from '@/utils/convertMoney';
import { styled } from '@mui/system';
import { style } from '@/styles/globals';
import FlexTableRow from '@/components/FlexTableRow';
import WideTableCell from '@/components/WideTableCell';

const getDataInSomeDate = (days: any) => {
  const sortedDays = days
    .filter((item: any) => !!item?.averageMinfare)
    .sort((a: any, b: any) => a?.averageMinfare - b?.averageMinfare);

  return uniqBy(sortedDays, (e: any) => e?.airline?.name);
};

const TableHeader = ['Hãng hàng không', 'Giá vé rẻ nhất', 'Ngày rẻ nhất 30 ngày tới'];

const CTABooking = styled('div')`
  ${style.text.content.bold}
  text-align: center;
  color: ${style.color.product3};
  cursor:pointer;
`;

export default function FareByAirlineInMonth({ days, onSelectTrip, isDesktop }: any) {
  const data = getDataInSomeDate(days);
  return (
    <TableContainer
      component={Paper}
      sx={{
        minHeight: '50px',
        mt: '8px',
        boxShadow: '0px 2px 10px rgba(7, 65, 57, 0.15)',
        borderRadius: '12px',
        overflow: 'hidden',
      }}
    >
      <Table
        sx={{ }}
        aria-label="simple table"
      >
        <TableHead>
          <FlexTableRow sx={{
            background: 'white',
            border: 0,
          }}
          >
            {TableHeader.map((label: string) => (
              <WideTableCell
                key={label}
                align="center"
              >
                {label}
              </WideTableCell>
            ))}
            {isDesktop && (
              <WideTableCell
                key={0}
                align="center"
              />

            )}
          </FlexTableRow>
        </TableHead>
        <TableBody>
          {(data || []).map((row: any) => (
            <FlexTableRow
              key={uniqueId()}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <WideTableCell align="center">{row?.airline?.name || 'Đang cập nhật'}</WideTableCell>
              <WideTableCell
                sx={{
                  fontWeight: '500',
                }}
                align="center"
              >
                {row?.averageMinfare ? convertMoney(row?.averageMinfare) : 'Đang cập nhật'}
              </WideTableCell>
              <WideTableCell align="center">
                <div>
                  {moment(row.date).format('DD/MM/YYYY')}
                </div>
                {!isDesktop && (

                <CTABooking onClick={() => onSelectTrip(row)}>
                  Đặt vé
                </CTABooking>
                )}
              </WideTableCell>
              {isDesktop && (
              <WideTableCell align="center">
                <CTABooking onClick={() => onSelectTrip(row)}>
                  Đặt vé
                </CTABooking>
              </WideTableCell>
              )}
            </FlexTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
